/**
 * What every "create a skill" path does once the POST resolves: refresh the
 * hub lists and land on the new skill's detail page, which is the flow's
 * preview and confirmation (there is no separate success screen).
 *
 * Platform difference, deliberate:
 * - native the builder is a formSheet pushed over the hub, so the detail route
 *   REPLACES it - a push would leave a dead sheet under the detail card and
 *   Back would return the user to a stale form.
 * - web the dialog is a portal that the caller closes first, so the detail
 *   route is PUSHED and browser Back returns to the hub.
 */
import { useCallback } from 'react';
import { Platform } from 'react-native';
import { useRouter } from 'expo-router';
import { useQueryClient } from '@tanstack/react-query';

export function useSkillCreated() {
  const router = useRouter();
  const queryClient = useQueryClient();

  return useCallback(
    (skillId: string) => {
      // Every hub query key starts with 'skills', so one invalidation covers
      // Explore, My skills and the chat slash menu.
      void queryClient.invalidateQueries({ queryKey: ['skills'] });
      if (!skillId) return;
      if (Platform.OS === 'web') {
        router.push(`/skills/${skillId}` as never);
        return;
      }
      router.replace(`/(app)/skills/${skillId}` as never);
    },
    [queryClient, router],
  );
}
